import { Fade, Zoom } from "react-awesome-reveal";
import IntroSectionBadge from "../../../../components/intro-section-badge/intro-section-badge";
import Map from "../../../../components/map/map";
import BoxIcon from "../../../../components/ui/box-icon/box-icon";
import CardDefault from "../../../../components/ui/cards/card-default/card-default";
import { SECTIONS_ID } from "../../../../constants/navigation";

import "./contacts-map.scss";

const ContactsMap = () => {
  return (
    <section className="contacts-map" id={SECTIONS_ID.contacts.map}>
      <Fade direction="up" duration={800} triggerOnce>
        <IntroSectionBadge
          title={"La Nostra Sede"}
          text={"Vieni a trovarci presso la nostra sede operativa"}
          bgColor={"light"}
        />
      </Fade>
      <Zoom duration={1000} delay={100} triggerOnce>
        <div className="contacts-map__map">
          <Map />
        </div>
      </Zoom>
      <Fade
        direction="up"
        duration={900}
        delay={200}
        cascade
        damping={0.15}
        triggerOnce
      >
        <div className="contacts-map__cards-list">
          <CardDefault type={"dark"} width="full-width">
            <div className="contacts-map__card">
              <div className="contacts-map__card-icon">
                <BoxIcon icon={"clock"} size={"small"} type={"primary"} />
              </div>
              <div className="contacts-map__card-description">
                <h3 className="contacts-map__card-title contacts-map__card-title--dark">
                  Orari di Lavoro
                </h3>
                <div className="contacts-map__card-text-container">
                  <span className="contacts-map__card-text contacts-map__card-text--dark">
                    Lun-Ven
                  </span>
                  <span className="contacts-map__card-text contacts-map__card-text--dark">
                    <span> 8:30-12:30</span> <span>14:30-18:30</span>
                  </span>
                </div>
              </div>
            </div>
          </CardDefault>
          <CardDefault type={"primary"} width="full-width">
            <div className="contacts-map__card">
              <div className="contacts-map__card-icon">
                <BoxIcon icon={"map-"} size={"small"} type={"secondary"} />
              </div>
              <div className="contacts-map__card-description">
                <h3 className="contacts-map__card-title contacts-map__card-title--primary">
                  Area di Servizio
                </h3>
                <div className="contacts-map__card-text-container">
                  <span className="contacts-map__card-text contacts-map__card-text--primary">
                    Veneto, Friuli Venezia Giulia,
                  </span>
                  <span className="contacts-map__card-text contacts-map__card-text--primary">
                    Emilia Romagna e regioni limitrofe
                  </span>
                </div>
              </div>
            </div>
          </CardDefault>
        </div>
      </Fade>
    </section>
  );
};

export default ContactsMap;
